// eslint-disable-next-line import/prefer-default-export
export var fontWeight;

(function (fontWeight) {
  fontWeight[fontWeight["regular"] = 400] = "regular";
  fontWeight[fontWeight["bold"] = 700] = "bold";
})(fontWeight || (fontWeight = {}));